var Actions;
(function (Actions) {
    Actions["UPDATE_ERROR"] = "updateError";
    Actions["RESET_ERROR"] = "resetError";
    Actions["UPDATE_FORM_INPUT_ERROR"] = "updateFormInputError";
    Actions["RESET_FORM_INPUT_ERROR"] = "resetFormInputError";
    Actions["TRIGGER_SWAL_ERROR_RESPONSE"] = "triggerSwalErrorResponse";
    Actions["TRIGGER_SWAL_ERROR_BULK_RESPONSE"] = "triggerSwalErrorBulkResponse";
    Actions["UPDATE_ERROR_TO_PAGE"] = "updateErrorToPage";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_IS_ERROR"] = "setIsError";
    Mutations["SET_ERROR_RESPONSE"] = "setErrorResponse";
    Mutations["SET_FORM_INPUT_ERROR_MESSAGES"] = "setformSubmitErrorMessages";
    Mutations["SET_IS_FORM_INPUT_ERROR"] = "setIsFormInputError";
    Mutations["SET_ERROR_PAGES"] = "setErrorPages";
    Mutations["SET_ERROR_ON_PAGES"] = "setErrorOnPages";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
